import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Modal, Paragraph, SectionTitle } from '@common/components';
import { COMMON_TRANSLATION, HELIX_SUPPORT_EMAIL } from '@common/constants';
import { Variants } from '@common/types';

import { TermsOfServiceUnavailableModalProps } from './TermsOfServiceUnavailableModal.types';
import { StyledActionsContainer, StyledContainer, StyledErrorIcon } from './TermsOfServiceUnavailableModal.styles';

const TermsOfServiceUnavailableModal: FC<TermsOfServiceUnavailableModalProps> = ({ isOpen, onLogout, onRetry }) => {
  const { t } = useTranslation(COMMON_TRANSLATION);

  return (
    <Modal show={isOpen}>
      <StyledContainer>
        <StyledErrorIcon />
        <SectionTitle data-testid="tos-title" css={{ fontWeight: '$bold' }}>
          {t('terms_of_service_unavailable.title')}
        </SectionTitle>
        <Paragraph>{t('terms_of_service_unavailable.description')}</Paragraph>
        <StyledActionsContainer>
          <Button id="tos-retry" onClick={onRetry}>
            {t('terms_of_service_unavailable.try_again')}
          </Button>
          <Button id="tos-logout" onClick={onLogout} css={{ marginTop: '$4' }} variant={Variants.TERTIARY}>
            {t('terms_of_service_unavailable.logout')}
          </Button>
        </StyledActionsContainer>
        <Box css={{ display: 'inline-flex' }}>
          <Box>{t('terms_of_service_unavailable.contact')}</Box>&nbsp;
          <a href={`mailto:${HELIX_SUPPORT_EMAIL}`}>{HELIX_SUPPORT_EMAIL}</a>
        </Box>
      </StyledContainer>
    </Modal>
  );
};

export default TermsOfServiceUnavailableModal;
